import { Command } from 'commander';
import { GenerateValidationCommand } from './generateValidationCommand';

export function ValidationCommand(): Command {
  const cmd = new Command('validation');
  cmd.alias('va').description('Validation related commands.');

  cmd.addCommand(GenerateValidationCommand());
  return cmd;
}
